import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Your Country Cabin', path: '/your-country-cabin' },
    { name: 'Your Host', path: '/your-host' },
    { name: 'Your Landscape', path: '/your-landscape' },
    { name: 'Brochure', path: '/brochure' },
    { name: 'Pitch Fee', path: '/pitch-fee' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#3a2f28]/95 backdrop-blur-md shadow-lg'
          : 'bg-gradient-to-b from-black/40 to-transparent backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="text-2xl lg:text-3xl font-light tracking-wider text-[#f5f1e8] hover:text-[#d4a574] transition-colors duration-300"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Your Setl
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm lg:text-base font-light tracking-wide transition-all duration-300 relative group ${
                  location.pathname === item.path
                    ? 'text-[#d4a574]'
                    : 'text-[#f5f1e8] hover:text-[#d4a574]'
                }`}
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {item.name}
                <span
                  className={`absolute -bottom-1 left-0 h-[2px] bg-[#d4a574] transition-all duration-300 ${
                    location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#f5f1e8] hover:text-[#d4a574] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="bg-[#3a2f28]/98 backdrop-blur-md px-6 py-4 space-y-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block text-base font-light tracking-wide transition-colors duration-300 ${
                location.pathname === item.path
                  ? 'text-[#d4a574]'
                  : 'text-[#f5f1e8] hover:text-[#d4a574]'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;